import { requestFetchConcepts, requestSaveConcepts } from '@cbgms/api/modules/customers/requests'
import * as types from './types'

export const fetchConcepts = (custEosId: string, appId: any) => ({
  type: [types.GET_CONCEPTS, types.GET_CONCEPTS_SUCCESS, types.GET_CONCEPTS_FAILED],
  payload: {
    api: 'support',
    request: requestFetchConcepts(custEosId, appId)
  },
  Data: []
})

export const saveConcepts = (changedModules: any) => ({
  type: [types.SAVE_CONCEPTS, types.SAVE_CONCEPTS_SUCCESS, types.SAVE_CONCEPTS_FAILED],
  payload: {
    api: 'support',
    request: requestSaveConcepts(changedModules)
  },
  Data: {}
})
